import { CheckCircleFilled } from '@ant-design/icons';
import { Tooltip } from 'antd';
import NextIcon from 'assets/icons/next.svg';
import {
    BUYER_CLASSIFICATION,
    SELLER_CLASSIFICATION,
} from 'presentation/components/HeaderRightComponent';
import { ImageComponent } from 'presentation/components/ImageComponent';
import { TooltipText } from 'presentation/components/TooltipText';
import { PRIVATE_ROUTES } from 'presentation/router/CONSTANTS';
import { useNavigate } from 'react-router-dom';
import { COMMON } from 'utilities/constants/COMMON';
import { commonHelpers } from 'utilities/helpers';
import { CardData } from '../models/CardModel';

interface props {
    data: CardData;
    type: number;
}

export const CardComponent = ({ data, type }: props) => {
    const navigate = useNavigate();

    const state = {
        currentTodo: data.currentTodo,
        memberTodo: data.memberTodo,
        bidPrice: data.bidPrice,
        purchaseAmount: data.purchaseAmount * 100,
    };
    const onClickViewDetail = (propertyId: number, listedPropertyid: number, auctionId: number) => {
        if (data.currentTodo && data.currentTodo.todoCode == '0001000090') {
            navigate(
                `${PRIVATE_ROUTES.PATH}/${PRIVATE_ROUTES.SUB.CU_017_01}/${listedPropertyid}?tabIndex=1&type=${type}${(data.settlementId && `&settlementId=${data.settlementId}`) || ''}&dealId=${data.dealId}`,
                { state: state },
            );
        } else {
            navigate(
                `${PRIVATE_ROUTES.PATH}/${PRIVATE_ROUTES.SUB.CU_002_03}/${listedPropertyid}/${propertyId}/${(auctionId && auctionId) || ''}?tabIndex=1&type=${type}${(data.settlementId && `&settlementId=${data.settlementId}`) || ''}&dealId=${data.dealId}`,
                { state: state },
            );
        }
    };
    return (
        <section
            className="card-element button-style glow-on-hover"
            onClick={() =>
                onClickViewDetail(data.propertyId, data.listedPropertyId, data.auctionId)
            }
        >
            <section className="font-[700] text-[#28323c]">
                {data?.currentTodo?.todoClassName} &nbsp;
            </section>
            <div style={{ width: '100%', height: 143, marginBottom: 24 }}>
                <ImageComponent alt="" width={231} height={143} src={data?.image} />
            </div>
            <section
                style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'end' }}
            >
                <div style={{ textAlign: 'left' }}>
                    <div className="todo-message" style={{ marginBottom: 9, width: '195px', height: '33px' }}>
                        <TooltipText
                            content={data?.currentTodo?.todoMessage01 ?? COMMON.EMPTY}
                            maxLine={3}
                        />
                    </div>
                    <div className="title" style={{ marginBottom: 9, width: '195px' }}>
                        <TooltipText
                            content={
                                data?.name 
                                ? `${data.name}${data?.roomNumber ?? ''}` 
                                : COMMON.EMPTY
                            }
                            maxLine={2}
                        />
                    </div>
                    <div style={{ display: 'flex', alignItems: 'center', marginBottom: 8 }}>
                        {type == BUYER_CLASSIFICATION &&
                            data?.currentTodo?.todoCode == '0002000020' && (
                                <div className="content" style={{ width: '195px' }}>
                                    <Tooltip
                                        title={`${commonHelpers.roundTenThousandYenFormat(data.currentHighestAuctionPrice)}万円`}
                                        color={'#ffffff'}
                                    >
                                        <span
                                            className={'tooltip-text'}
                                            style={{ WebkitLineClamp: 1 }}
                                        >
                                            <strong
                                                style={{ fontSize: 14 }}
                                            >{`${commonHelpers.roundTenThousandYenFormat(data.currentHighestAuctionPrice)}万円`}</strong>{' '}
                                            最高入札額
                                        </span>
                                    </Tooltip>
                                </div>
                            )}
                        {type == BUYER_CLASSIFICATION &&
                            data?.currentTodo?.todoCode == '0002000030' && (
                                <div className="content" style={{ width: '195px' }}>
                                    <Tooltip
                                        title={`${commonHelpers.roundTenThousandYenFormat(data.bidPrice)}万円`}
                                        color={'#ffffff'}
                                    >
                                        <span
                                            className={'tooltip-text'}
                                            style={{ WebkitLineClamp: 1 }}
                                        >
                                            <strong
                                                style={{ fontSize: 14 }}
                                            >{`${commonHelpers.roundTenThousandYenFormat(data.bidPrice)}万円`}</strong>{' '}
                                            購入額
                                        </span>
                                    </Tooltip>
                                </div>
                            )}
                        {type == BUYER_CLASSIFICATION &&
                            data?.currentTodo?.todoCode == '0002000040' && (
                                <div className="content" style={{ width: '195px' }}>
                                    <Tooltip
                                        title={`${commonHelpers.roundTenThousandYenFormat(data.bidPrice)}万円`}
                                        color={'#ffffff'}
                                    >
                                        <span
                                            className={'tooltip-text'}
                                            style={{ WebkitLineClamp: 1 }}
                                        >
                                            <strong
                                                style={{ fontSize: 14 }}
                                            >{`${commonHelpers.roundTenThousandYenFormat(data.bidPrice)}万円`}</strong>{' '}
                                            購入額
                                        </span>
                                    </Tooltip>
                                </div>
                            )}
                        {type == SELLER_CLASSIFICATION &&
                            ['0001000080', '0001000090', '0001000100'].includes(
                                data?.currentTodo?.todoCode,
                            ) && (
                                <div className="content" style={{ width: '195px' }}>
                                    <Tooltip
                                        title={`${commonHelpers.roundTenThousandYenFormat(data.currentHighestAuctionPrice)}万円`}
                                        color={'#ffffff'}
                                    >
                                        <span
                                            className={'tooltip-text'}
                                            style={{ WebkitLineClamp: 1 }}
                                        >
                                            <strong
                                                style={{ fontSize: 14 }}
                                            >{`${commonHelpers.roundTenThousandYenFormat(data.currentHighestAuctionPrice)}万円`}</strong>{' '}
                                            最高入札額
                                        </span>
                                    </Tooltip>
                                </div>
                            )}
                        {type == SELLER_CLASSIFICATION &&
                            data?.currentTodo?.todoCode == '0001000110' && (
                                <div className="content" style={{ width: '195px' }}>
                                    <Tooltip
                                        title={`${commonHelpers.roundTenThousandYenFormat(data.marketPrice)}万円`}
                                        color={'#ffffff'}
                                    >
                                        <span
                                            className={'tooltip-text'}
                                            style={{ WebkitLineClamp: 1 }}
                                        >
                                            <strong
                                                style={{ fontSize: 14 }}
                                            >{`${commonHelpers.roundTenThousandYenFormat(data.askingSalePrice)}万円`}</strong>{' '}
                                            仮相場価格
                                        </span>
                                    </Tooltip>
                                </div>
                            )}
                        {type == SELLER_CLASSIFICATION &&
                            data?.currentTodo?.todoCode == '0001000120' && (
                                <div className="content" style={{ width: '195px' }}>
                                    <Tooltip
                                        title={`${commonHelpers.roundTenThousandYenFormat(data.bidPrice)}万円`}
                                        color={'#ffffff'}
                                    >
                                        <span
                                            className={'tooltip-text'}
                                            style={{ WebkitLineClamp: 1 }}
                                        >
                                            <strong
                                                style={{ fontSize: 14 }}
                                            >{`${commonHelpers.roundTenThousandYenFormat(data.bidPrice)}万円`}</strong>{' '}
                                            売却価格
                                        </span>
                                    </Tooltip>
                                </div>
                            )}
                    </div>
                    <div style={{ display: 'flex', alignItems: 'center' }}>
                        {data?.currentTodo && data?.currentTodo.todoName && (
                            <div className="content">
                                <CheckCircleFilled
                                    style={{
                                        fontSize: 14,
                                        opacity:
                                            data.currentTodo.todoExecStatus == 'DONE'
                                                ? 'unset'
                                                : 0.3,
                                        width: 20,
                                        color:
                                            data.currentTodo.todoExecStatus == 'DONE'
                                                ? '#1F8DDD'
                                                : 'unset',
                                    }}
                                />
                                {data?.currentTodo.todoName}
                            </div>
                        )}
                    </div>
                </div>
                <div className="button-style">
                    <img alt="" src={NextIcon} />
                </div>
            </section>
        </section>
    );
};
